import React, { useState } from 'react';
import { Text, i18n, tokens } from '@simplybenefits/sb-ui-library';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { Add as AddIcon, Remove as RemoveIcon } from '@mui/icons-material';
import EnrichedAcademyModal from '../../components/EnrichedAcademyModal.js';

/**
 *
 * @param {*} props
 */
const FinancialAwareness = ({ classes, expanded, financialAwareness, handleChange }) => {
    const [ modalOpen, setModalOpen ] = useState(false);

    return (
        <div style={ classes.block }>
            <Accordion
                square
                onChange={handleChange('financialAwareness')}
                style={{ boxShadow: 'none' }}
                disableGutters={true}
            >
                <AccordionSummary
                    classes={{
                        content: classes.panelContent,
                        expanded: classes.expanded,
                        root: classes.root
                    }}
                    sx={classes.accordionSummary}
                    expandIcon={expanded.includes('financialAwareness') ? <RemoveIcon /> : <AddIcon />}
                >
                    <Text medium bold>{ i18n.t(tokens.titles.financialAwareness) }</Text>
                </AccordionSummary>

                <AccordionDetails style={classes.panelDetails}>
                    <React.Fragment>
                        {
                            !financialAwareness.isEligible === 1 ?
                                <div style={classes.row}>
                                    <Text small bold margin="20px 0px 10px 0px">
                                You are currently ineligible for this benefit, if this is a mistake please contact your administrator.
                                    </Text>
                                </div>
                                :
                                null
                        }
                        {
                            financialAwareness.includeEnrichedAcademy === 1 &&
                            <>
                                <Text small margin="20px 0px 0px 0px">
                                    { i18n.t(tokens.labels.coverage.enrichedAcademyDescription) }
                                </Text>
                                <ul style={{ listStyle: 'disc', paddingLeft: '16px', marginLeft: '1px' }}>
                                    <li><Text small margin="0px 0px 0px 0px"> { i18n.t(tokens.labels.coverage.enrichedAcademyPoint1) }</Text></li>
                                    <li><Text small margin="5px 0px 0px 0px"> { i18n.t(tokens.labels.coverage.enrichedAcademyPoint2) }</Text></li>
                                    <li><Text small margin="5px 0px 0px 0px"> { i18n.t(tokens.labels.coverage.enrichedAcademyPoint3) }</Text></li>
                                    <li><Text small margin="5px 0px 0px 0px"> { i18n.t(tokens.labels.coverage.enrichedAcademyPoint4) }</Text></li>
                                </ul>

                                {
                                    financialAwareness.isEligible === 1 ?
                                        <Text 
                                            onClick={() => setModalOpen(true)} 
                                            small 
                                            margin="10px 0px 0px 0px"
                                            customStyle={{ textDecoration: 'underline', cursor: 'pointer' }}
                                        >
                                            { i18n.t(tokens.labels.coverage.getStartedWithEnrichedAcademy) }
                                        </Text>
                                        :
                                        null
                                }
                            </>
                        }
                    </React.Fragment>
                    
                    <EnrichedAcademyModal 
                        open={modalOpen}
                        toggleOpen={() => setModalOpen(!modalOpen)}
                    />
                </AccordionDetails>
            </Accordion>
        </div>
    );
};

export default (FinancialAwareness);